import { useEffect, useRef } from 'react';
import './MarqueeScroll.css';

// Agency-relevant marquee words with bullet separators
const ITEMS = [
  'Performance Marketing',
  '✦',
  'Meta & Google Ads',
  '✦',
  'Data Analytics',
  '✦',
  'AI Automation',
  '✦',
  'CRO & Funnels',
  '✦',
  'Shopify Development',
  '✦',
  'Dashboard Design',
  '✦',
  'Email & WhatsApp Flows',
  '✦',
];

// Duplicate enough times to fill any screen width
const REPEATED = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
const BASE_VEL = -0.6; // auto-scroll speed (negative = left)

export default function MarqueeScroll() {
  const track1Ref = useRef(null);
  const track2Ref = useRef(null);
  const velRef    = useRef(0); // current velocity (px/frame)
  const rafRef    = useRef(null);
  const pos1      = useRef(0);
  const pos2      = useRef(0);

  useEffect(() => {
    const track1 = track1Ref.current;
    const track2 = track2Ref.current;
    if (!track1 || !track2) return;

    // Init row 2 offset so rows go in opposite directions
    pos2.current = 0;

    let lastScrollY = window.scrollY;

    const onScroll = () => {
      const delta = window.scrollY - lastScrollY;
      lastScrollY = window.scrollY;
      // Boost velocity proportional to scroll delta
      velRef.current += delta * 0.04;
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    const tick = () => {
      // Decay velocity toward base auto-scroll speed
      velRef.current += (BASE_VEL - velRef.current) * 0.06;

      // Row 1 — moves left (negative direction)
      pos1.current += velRef.current;
      // Row 2 — moves right (opposite direction)
      pos2.current -= velRef.current;

      const w1 = track1.scrollWidth / 2; // half = one set of items
      const w2 = track2.scrollWidth / 2;

      // Seamless loop
      if (pos1.current <= -w1) pos1.current += w1;
      if (pos1.current > 0)    pos1.current -= w1;
      if (pos2.current <= -w2) pos2.current += w2;
      if (pos2.current > 0)    pos2.current -= w2;

      track1.style.transform = `translateX(${pos1.current}px)`;
      track2.style.transform = `translateX(${pos2.current}px)`;

      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <section className="mqs-section">
      {/* Row 1 — left */}
      <div className="mqs-row mqs-row--1">
        <div className="mqs-track" ref={track1Ref}>
          {REPEATED.map((item, i) => (
            <span key={i} className={item === '✦' ? 'mqs-dot' : 'mqs-item'}>
              {item}
            </span>
          ))}
        </div>
      </div>

      {/* Row 2 — right (opposite) */}
      <div className="mqs-row mqs-row--2">
        <div className="mqs-track" ref={track2Ref}>
          {REPEATED.map((item, i) => (
            <span key={i} className={item === '✦' ? 'mqs-dot' : 'mqs-item'}>
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
